import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../lib/loopback'

const analistaUnidadeNegocioRepository = createRepository({
  path: 'analista-unidadeNegocio',
  parentPath: 'unidadeNegocio',
  relationType: 'path',
  restApi,
  queryTransform: {
    ...paginate
  }
})

analistaUnidadeNegocioRepository.remove = async ({ id }) => {
  if (!id) throw new Error('ID é obrigatório para delete')
  const uri = `analista-unidadeNegocio/${id}`
  const response = await restApi.delete(uri)
  return {
    ok: response.ok,
    data: response.data
  }
}

analistaUnidadeNegocioRepository.getOne = ({ id }) => {
  return restApi.get(`analista-unidadeNegocio/${id}`)
}

export default analistaUnidadeNegocioRepository
